/* ======================================================
   MANUALSKART SALES POPUP
   Part 1A - Product Data
====================================================== */

const popupProducts = [

{
title:"Kubota KX040-4 Excavator PDF Repair Service Manual",
url:"https://manualskart.com/products/kubota-kx040-4-excavator-pdf-repair-service-manual",
image:"https://manualskart.com/cdn/shop/files/kubota.jpg?v=1759751724&width=600"
},

{
title:"New Holland C327, C332, C338 Compact Track Loader PDF Repair Service Manual",
url:"https://manualskart.com/products/new-holland-c327-c332-c338-compact-track-loader-pdf-repair-service-manual",
image:"https://manualskart.com/cdn/shop/files/new-holland-c327-c332-c338-compact-track-loader-pdf-repair-service-manual.png?v=1742790956&width=600"
},

{
title:"Caterpillar C15 6NZ Truck Engine Repair Manual Instant Download",
url:"https://manualskart.com/products/caterpillar-c15-6nz-truck-engine-repair-manual-instant-download",
image:"https://manualskart.com/cdn/shop/files/caterpillar-c15-mxs-truck-engine-repair-manual-instant-access.jpg?v=1746710848&width=600"
},

{
title:"Caterpillar 299D3 Compact Track Loader PDF Repair Service Manual",
url:"https://manualskart.com/products/caterpillar-299d3-compact-track-loader-pdf-repair-service-manual",
image:"https://manualskart.com/cdn/shop/files/caterpillar-299d3-compact-track-loader-pdf-repair-service-manual.jpg?v=1739347373&width=600"
},

{
title:"Caterpillar 259D3 Compact Track Loader PDF Operation and Maintenance Manual",
url:"https://manualskart.com/products/caterpillar-259d3-compact-track-loader-pdf-operation-and-maintenance-manual",
image:"https://manualskart.com/cdn/shop/files/caterpillar-259d3-compact-track-loader-pdf-operation-and-maintenance-manual.jpg?v=1741155142&width=600"
},

{
title:"Volvo BM 4400 Wheel Loader PDF Repair Service Manual",
url:"https://manualskart.com/products/volvo-bm-4400-wheel-loader-pdf-repair-service-manual-1",
image:"https://manualskart.com/cdn/shop/files/volvo-bm-4400-wheel-loader-pdf-repair-service-manual_bc3d8df1-a2b6-4c42-8260-82ca888b4253.jpg?v=1768830321&width=600"
},

{
title:"Volvo ECR145C L Excavator PDF Repair Service Manual",
url:"https://manualskart.com/products/volvo-ecr145c-l-excavator-pdf-repair-service-manual",
image:"https://manualskart.com/cdn/shop/files/volvo-ecr145c-l-excavator-pdf-repair-service-manual.webp?v=1714305966&width=600"
},

{
title:"Case IH 7210 7220 7230 7240 7250 Tractor PDF Workshop Service Repair Manual",
url:"https://manualskart.com/products/case-ih-7210-7220-7230-7240-7250-tractor-pdf-workshop-service-repair-manual",
image:"https://manualskart.com/cdn/shop/files/case-ih-7210-7220-7230-7240-7250-tractor-pdf-workshop-service-repair-manual_a849bad7-b3f8-4a63-a2a9-f83e6f1c0e19.jpg?v=1781171480&width=600"
},

{
title:"Volvo L90H Wheel Loader PDF Parts Manual",
url:"https://manualskart.com/products/volvo-l90h-wheel-loader-pdf-parts-manual",
image:"https://manualskart.com/cdn/shop/files/volvo-l90h-wheel-loader-pdf-parts-manual.webp?v=1713341235&width=600"
},

{
title:"New Holland G170, G190, G210, G240 HD Tractor PDF Repair Service Manual",
url:"https://manualskart.com/products/new-holland-g170-g190-g210-g240-hd-tractor-pdf-repair-service-manual-p-nb-6035430100",
image:"https://manualskart.com/cdn/shop/files/new-holland-g170-g190-g210-g240-hd-tractor-pdf-repair-service-manual-p-nb-6035430100.jpg?v=1718545916&width=600"
},

{
title:"Case IH RBX441, RBX451, RBX461, RBX561 Round Baler Pdf Service Repair Manual",
url:"https://manualskart.com/products/case-ih-rbx441-rbx451-rbx461-rbx561-round-baler-pdf-service-repair-manual",
image:"https://manualskart.com/cdn/shop/files/case-ih-rbx441-rbx451-rbx461-rbx561-round-baler-pdf-service-repair-manual.jpg?v=1716795710&width=600"
},

{
title:"Volvo ECR88 Compact Excavator Pdf Repair Service Manual",
url:"https://manualskart.com/products/volvo-ecr88-compact-excavator-repair-service-pdf-manual",
image:"https://manualskart.com/cdn/shop/files/volvo-ecr88-compact-excavator-repair-service-pdf-manual.jpg?v=1768831501&width=600"
},

{
title:"Case IH 8910 8920 8930 8940 8950 Magnum Tractor Pdf Service Repair Manual",
url:"https://manualskart.com/products/case-ih-8910-8920-8930-8940-8950-magnum-tractor-pdf-service-repair-manual",
image:"https://manualskart.com/cdn/shop/files/case-ih-8910-8920-8930-8940-8950-magnum-tractor-pdf-service-repair-manual_5c29dbd6-616c-40c6-a80a-d2aa428aefea.jpg?v=1781170953&width=600"
},

{
title:"Case IH Mx90c Mx100c Tractor Pdf Service Repair Manual",
url:"https://manualskart.com/products/case-ih-mx90c-mx100c-tractor-pdf-service-repair-manual",
image:"https://manualskart.com/cdn/shop/files/case-ih-mx90c-mx100c-tractor-pdf-service-repair-manual.webp?v=1717842914&width=600"
},

{
title:"New Holland TT60A TT75A Tractors Pdf Repair Service Manual (p. Nb. 84154801)",
url:"https://manualskart.com/products/new-holland-tt60a-tt75a-tractors-pdf-repair-service-manual-p-nb-84154802",
image:"https://manualskart.com/cdn/shop/files/new-holland-tt60a-tt75a-tractors-pdf-repair-service-manual-p-nb-84154801_dcd73860-cc74-401c-84b2-7ff8c9681ddf.jpg?v=1769675090&width=600"
},

{
title:"Volvo L50D Wheel Loader Service Repair Manual Pdf",
url:"https://manualskart.com/products/volvo-l50d-wheel-loader-pdf-repair-service-manual-1",
image:"https://manualskart.com/cdn/shop/files/volvo-l50d-wheel-loader-pdf-repair-service-manual.jpg?v=1742653872&width=600"
},

{
title:"Case IH Maxxum 5130, 5140, 5220, 5230, 5240, 5250 Tractor Pdf Service Repair Manual",
url:"https://manualskart.com/products/case-ih-maxxum-5130-5140-5220-5230-5240-5250-tractor-pdf-service-repair-manual",
image:"https://manualskart.com/cdn/shop/files/case-ih-maxxum-5130-5140-5220-5230-5240-5250-tractor-pdf-service-repair-manual_719f2234-8627-46a1-a32a-62b2c284653d.jpg?v=1781164649&width=600"
},

{
title:"New Holland Workmaster 33, Workmaster 37 Compact Tractor Pdf Repair Service Manual (p. Nb. 47881877)",
url:"https://manualskart.com/products/new-holland-workmaster-33-workmaster-37-compact-tractor-pdf-repair-service-manual-p-nb-47881877",
image:"https://manualskart.com/cdn/shop/files/new-holland-workmaster-33-workmaster-37-compact-tractor-pdf-repair-service-manual-p-nb-47881877_2.jpg?v=1717925389&width=600"
},

{
title:"Volvo L90H Wheel Loader Service Repair Manual Pdf",
url:"https://manualskart.com/products/volvo-l90h-wheel-loader-service-repair-pdf-manual",
image:"https://manualskart.com/cdn/shop/files/volvo-l90h-wheel-loader-service-repair-pdf-manual.jpg?v=1768841350&width=600"
},

{
title:"New Holland TT60A TT75A Tractors Pdf Repair Service Manual (p. Nb. 84154801)",
url:"https://manualskart.com/products/new-holland-tt60a-tt75a-tractors-pdf-repair-service-manual-p-nb-84154802",
image:"https://manualskart.com/cdn/shop/files/new-holland-tt60a-tt75a-tractors-pdf-repair-service-manual-p-nb-84154801_dcd73860-cc74-401c-84b2-7ff8c9681ddf.jpg?v=1769675090&width=600"
},

{
title:"Case IH 8910 8920 8930 8940 8950 Tractor Pdf Workshop Service Repair Manual",
url:"https://manualskart.com/products/case-ih-8910-8920-8930-8940-8950-tractor-pdf-workshop-service-repair-manual",
image:"https://manualskart.com/cdn/shop/files/case-ih-8910-8920-8930-8940-8950-tractor-pdf-workshop-service-repair-manual_aa851faf-3f21-4ebe-a524-c1338f275844.jpg?v=1781171166&width=600"
},

{
title:"New Holland C245 Compact Track Loader Pdf Parts Catalog Manual Download",
url:"https://manualskart.com/products/new-holland-c245-compact-track-loader-pdf-parts-catalog-manual-download",
image:"https://manualskart.com/cdn/shop/files/new-holland-c245-compact-track-loader-pdf-parts-catalog-manual-download.jpg?v=1716211836&width=600"
},

];

const popupNames = [
"John Smith",
"Michael Johnson",
"David Williams",
"Robert Brown",
"James Jones",
"William Garcia",
"Daniel Miller",
"Thomas Davis",
"Joseph Rodriguez",
"Christopher Martinez",
"Matthew Hernandez",
"Mark Lopez",
"Anthony Gonzalez",
"Richard Wilson",
"Charles Anderson",
"Andrew Thomas",
"Joshua Taylor",
"Kevin Moore",
"Brian Jackson",
"Steven Martin",
"Eric Lee",
"Ryan Perez",
"Jason Thompson",
"Justin White",
"Brandon Harris",
"Jonathan Sanchez"
];

const popupCountries = [
"Germany",
"United States",
"Canada",
"Australia",
"United Kingdom",
"France",
"Italy",
"Netherlands",
"Spain",
"Sweden",
"Norway",
"Switzerland"
];

function randomName(){
return popupNames[Math.floor(Math.random()*popupNames.length)];
}

function randomCountry(){
return popupCountries[Math.floor(Math.random()*popupCountries.length)];
}

function randomTime(){

const minutes=Math.floor(Math.random()*119)+2;

if(minutes<60){
return minutes+" minutes ago";
}

const hour=Math.floor(minutes/60);
const remain=minutes%60;

if(remain===0){
return hour+(hour>1?" hours ago":" hour ago");
}

return hour+(hour>1?" hours ":" hour ")+remain+" minutes ago";

}

/* ======================================================
   Part 1B - Popup HTML
====================================================== */

let lastProduct = -1;

function getRandomProduct() {

    let index;

    do{

        index = Math.floor(Math.random() * popupProducts.length);

    }while(index === lastProduct);

    lastProduct = index;

    return popupProducts[index];

}

const popup = document.createElement("div");

popup.id = "mk-sales-popup";

popup.innerHTML = `

<div class="mk-popup-image">

<a id="mk-popup-image-link" href="#">

<img id="mk-popup-image" src="" alt="">

</a>

</div>

<div class="mk-popup-content">
<div class="mk-popup-verified">

<span class="mk-green-dot"></span>

Verified Purchase

</div>


<a id="mk-popup-title"

class="mk-popup-title"

href="#"

target="_self">

Loading...

</a>

<div class="mk-popup-info">

<strong id="mk-popup-name"></strong>

from

<strong id="mk-popup-country"></strong>

purchased

</div>

<div class="mk-popup-time"

id="mk-popup-time">

</div>

</div>

<div class="mk-popup-close"

id="mk-popup-close">

&times;

</div>

`;

document.addEventListener("DOMContentLoaded",function(){

    document.body.appendChild(popup);

});

const popupImage = ()=>document.getElementById("mk-popup-image");

const popupTitle = ()=>document.getElementById("mk-popup-title");

const popupImageLink = ()=>document.getElementById("mk-popup-image-link");

const popupName = ()=>document.getElementById("mk-popup-name");

const popupCountry = ()=>document.getElementById("mk-popup-country");

const popupTime = ()=>document.getElementById("mk-popup-time");

const popupClose = ()=>document.getElementById("mk-popup-close");

/* ======================================================
   Part 1C - Premium Popup Logic
====================================================== */

let popupVisible = false;
let popupTimer = null;

function showPopup() {

    if (popupVisible) return;

    popupVisible = true;

    const product = getRandomProduct();

    popupImage().src = product.image;
    popupImage().alt = product.title;

    popupTitle().textContent = product.title;
    popupTitle().href = product.url;

    popupImageLink().href = product.url;

    popupName().textContent = randomName();
    popupCountry().textContent = randomCountry();
    popupTime().textContent = randomTime();

    popup.classList.add("show");

    popupTimer = setTimeout(function(){

        hidePopup();

    },10000);

}

function hidePopup(){

    popup.classList.remove("show");

    popupVisible = false;

    clearTimeout(popupTimer);

    // Wait 3 seconds before showing next popup
    setTimeout(function(){

        showPopup();

    },5000);

}

document.addEventListener("DOMContentLoaded",function(){

    popupClose().addEventListener("click",function(){

        hidePopup();

    });

    // First popup after 5 seconds
    setTimeout(function(){

        showPopup();

    },5000);

});